import type { Variants } from "framer-motion"

/** Matches CSS `--ease-standard` / `--animation-timing` — use for entrances and state changes */
export const EASE_STANDARD = [0.2, 0.8, 0.2, 1] as const

/** Page and shell layout motion — keep ≤300ms for snappy UI */
export const shellTransition = {
  duration: 0.26,
  ease: EASE_STANDARD,
} as const

/** Snappy spring for modals — settles quickly without mixing long `duration` with spring */
export const modalSpringTransition = {
  type: "spring" as const,
  stiffness: 520,
  damping: 36,
}

/** Context menus / dropdowns: no entrance motion; exit uses ease-in */
export const menuPanelInstantEnter = {
  initial: { opacity: 1, y: 0, scale: 1 },
  animate: { opacity: 1, y: 0, scale: 1 },
} as const

export const menuPanelExitTransition = {
  duration: 0.16,
  ease: [0.4, 0, 1, 1] as const,
}

export const containerVariants: Variants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05,
      delayChildren: 0.06,
    },
  },
}

export const itemVariants: Variants = {
  hidden: {
    opacity: 0,
    y: 12,
  },
  visible: (custom = 0) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: custom * 0.05,
      duration: 0.28,
      ease: EASE_STANDARD,
    },
  }),
}

export const sidebarVariants: Variants = {
  hidden: {
    x: "-100%",
    transition: {
      type: "tween",
      duration: 0.22,
      ease: [0.4, 0, 1, 1],
    },
  },
  visible: {
    x: 0,
    transition: {
      type: "tween",
      duration: 0.24,
      ease: [0.2, 0.8, 0.2, 1],
    },
  },
}

export const overlayVariants: Variants = {
  hidden: {
    opacity: 0,
    transition: { duration: 0.16 },
  },
  visible: {
    opacity: 1,
    transition: { duration: 0.16 },
  },
}

export const dropdownVariants: Variants = {
  hidden: {
    height: 0,
    opacity: 0,
    y: -6,
    transition: {
      height: { duration: 0.2, ease: [0.4, 0, 1, 1] },
      opacity: { duration: 0.12 },
      y: { duration: 0.12 },
    },
  },
  visible: {
    height: "auto",
    opacity: 1,
    y: 0,
    transition: {
      height: { duration: 0.22, ease: [0.2, 0.8, 0.2, 1] },
      opacity: { duration: 0.14, delay: 0.02 },
      y: { duration: 0.14, delay: 0.02 },
    },
  },
}
